import { useIsAuthenticated } from "@azure/msal-react"
import { Typography } from "@mui/material"
import Stack from "@mui/material/Stack"
import { FC, useEffect, useState } from "react"

import { create } from "src/helpers/bem"
import { hasOrderAuthorizationParam } from "src/helpers/orderAuthorizationLink"
import { useTranslation } from "src/hooks/translation"
import { fetchWebshopIncidents } from "src/queriesXRM/incident"
import { isAccountIncomplete } from "src/states/account"
import { mergeDialog } from "src/states/dialogs"
import { SharedPageProps } from "src/types/SharedPageProps"

import { CreateRequestCard } from "./get-support/CreateRequestCard"
import { GetSupportCard } from "./get-support/GetSupportCard"
import styles from "./IncidentOverview.module.scss"
import { IncidentsTable } from "./IncidentsTable"

const bem = create(styles, "IncidentOverview")

interface IncidentOverviewProps extends SharedPageProps {}

export const IncidentOverview: FC<IncidentOverviewProps> = ({
  messages,
  page,
}) => {
  const hasIncompleteAccount = isAccountIncomplete()
  const isAuthenticated = useIsAuthenticated()
  const { messages: translations } = useTranslation()
  const title = translations.pages.account.overview.navigation.support
  // The order authorization card is only shown when the page is opened via
  // the order authorization link (see src/helpers/orderAuthorizationLink.ts)
  const [showAuthorizationRequest, setShowAuthorizationRequest] =
    useState(false)

  useEffect(() => {
    const fetchIncidents = async () => {
      await fetchWebshopIncidents()
    }
    fetchIncidents()
  }, [])

  useEffect(() => {
    const isAuthorizationLink = isAuthenticated && hasOrderAuthorizationParam()
    setShowAuthorizationRequest(isAuthorizationLink)
    if (isAuthorizationLink) {
      mergeDialog("incidentDialog", { open: true, disabled: false })
    }
  }, [isAuthenticated])

  return (
    <Stack className={bem("content")} direction={"column"} spacing={3.5}>
      <Stack direction={"row"} justifyContent={"space-between"}>
        <Typography className={bem("title")} variant={"h1"}>
          {title}
        </Typography>
      </Stack>
      <GetSupportCard page={page} />
      {showAuthorizationRequest && <CreateRequestCard />}
      {!hasIncompleteAccount && <IncidentsTable messages={messages} />}
    </Stack>
  )
}
